import React from 'react'
import { Link } from 'react-router-dom'

import Navbar from '../../components/navbar'
import VideoModalOne from '../../components/video-modal-one'
import Partner from '../../components/partner'
import BgParallax from '../../components/bg-parallax'
import ClientTwo from '../../components/client-two'
import PricingTwo from '../../components/pricing-two'
import Footer from '../../components/footer'

import analytics1 from '../../assets/images/analytics/1.png'
import analytics2 from '../../assets/images/analytics/2.png'
import analytics3 from '../../assets/images/analytics/3.png'
import analytics4 from '../../assets/images/analytics/4.png'
import phoneImg from '../../assets/images/analytics/phone.png'
import about1 from '../../assets/images/ab01.jpg'
import about2 from '../../assets/images/ab02.jpg'
import about3 from '../../assets/images/ab03.jpg'
import about4 from '../../assets/images/ab04.jpg'
import bg1 from '../../assets/images/app/cta.jpg'

import { featureData } from '../../data/agency-data'


export default function IndexAnalytics() {
  return (
    <>
    <Navbar/> 

    <section className="bg-half-170 d-table w-100">
      <div className="container">
          <div className="row mt-5 align-items-center">
              <div className="col-md-6">
                  <div className="title-heading">
                      <h4 className="heading">Boost social reach for your brand</h4>
                      <p className="para-desc text-muted">Start work with <span className="text-primary">Leaping</span>. Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                      <div className="watch-video mt-4 pt-2">
                          <Link to="#" className="btn btn-primary mb-2 me-2">Get Started</Link>
                          <div className="watch-video mt-4 pt-2 d-inline-block">
                              <VideoModalOne/>
                          </div>
                      </div>
                  </div>
              </div>

              <div className="col-md-6 order-2 order-md-1 mt-4 mt-sm-0 pt-2 pt-sm-0">
                  <div className="row align-items-center ms-lg-5">
                      <div className="col-lg-6 col-md-6 col-6">
                          <div className="row">
                              <div className="col-lg-12 col-md-12 spacing">
                                  <div className="card rounded border-0 overflow-hidden">
                                      <img src={analytics1} className="img-fluid" alt=""/>
                                  </div>
                              </div>

                              <div className="col-lg-12 col-md-12 spacing">
                                  <div className="card rounded border-0 shadow overflow-hidden">
                                      <img src={analytics2} className="img-fluid" alt=""/>
                                  </div>
                              </div>
                          </div>
                      </div>

                      <div className="col-lg-6 col-md-6 col-6">
                          <div className="row">
                              <div className="col-lg-12 col-md-12 spacing">
                                  <div className="card rounded border-0 shadow overflow-hidden">
                                      <img src={analytics3} className="img-fluid" alt=""/>
                                  </div>
                              </div>

                              <div className="col-lg-12 col-md-12 spacing">
                                  <div className="card rounded border-0 shadow overflow-hidden">
                                      <img src={analytics4} className="img-fluid" alt=""/>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
    </section>

    <div className="container">
      <Partner/>
    </div>

    <section className="section">
      <div className="container">
          <div className="row justify-content-center">
              <div className="col-12 text-center">
                  <div className="section-title mb-4 pb-2">
                      <h4 className="title mb-4">Build from our powerful tools</h4>
                      <p className="text-muted para-desc mx-auto mb-0">Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                  </div>
              </div>
          </div>

          <div className="row">
            {featureData.map((item,index)=>{
              return(
                <div className="col-md-4 col-12 mt-4 pt-2" key={index}>
                    <div className="features text-center px-lg-4">
                        <img src={item.image} className="avatar avatar-small" alt=""/>
                        <div className="content">
                            <h4 className="title mt-4">{item.title}</h4>
                            <p className="text-muted mb-0">{item.desc}</p>
                        </div>
                    </div>
                </div>
              )
            })}
          </div>
      </div>

      <div className="container mt-100 mt-60">
          <div className="row align-items-center">
              <div className="col-md-6">
                  <img src={phoneImg} className="img-fluid" alt=""/>
              </div>

              <div className="col-md-6 mt-4 mt-sm-0 pt-2 pt-sm-0">
                  <div className="section-title">
                      <h4 className="title mb-4">Fast to installed <br/><span className="text-primary">Simple to use</span></h4>
                      <p className="text-muted para-desc">Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                      <ul className="list-inline mb-0">
                          <li className="h6"><i className="mdi mdi-check-circle-outline text-primary h5 mb-0 me-2 align-middle"></i> Can I upgrade later on?</li>
                          <li className="h6"><i className="mdi mdi-check-circle-outline text-primary h5 mb-0 me-2 align-middle"></i> Can I port my data from another provider?</li>
                          <li className="h6"><i className="mdi mdi-check-circle-outline text-primary h5 mb-0 me-2 align-middle"></i> Are my food photos stored forever in the cloud?</li>
                          <li className="h6"><i className="mdi mdi-check-circle-outline text-primary h5 mb-0 me-2 align-middle"></i> Who foots the bill for that?</li>
                      </ul>
                      <div className="mt-4">
                          <Link to="#" className="text-primary">Learn More <i className="mdi mdi-chevron-right align-middle"></i></Link>
                      </div>
                  </div>
              </div>
          </div>
      </div>

      <div className="container mt-100 mt-60">
          <div className="row align-items-center">
              <div className="col-md-6 order-1 order-md-2 text-end">
                  <div className="row align-items-center ms-lg-5">
                      <div className="col-lg-6 col-md-6 col-6">
                          <div className="row">
                              <div className="col-lg-12 col-md-12 spacing">
                                  <div className="card rounded border-0 overflow-hidden">
                                      <img src={about1} className="img-fluid" alt=""/>
                                  </div>
                              </div>

                              <div className="col-lg-12 col-md-12 spacing">
                                  <div className="card rounded border-0 shadow overflow-hidden">
                                      <img src={about2} className="img-fluid" alt=""/>
                                  </div>
                              </div>
                          </div>
                      </div>

                      <div className="col-lg-6 col-md-6 col-6">
                          <div className="row">
                              <div className="col-lg-12 col-md-12 spacing">
                                  <div className="card rounded border-0 shadow overflow-hidden">
                                      <img src={about3} className="img-fluid" alt=""/>
                                  </div>
                              </div>

                              <div className="col-lg-12 col-md-12 spacing">
                                  <div className="card rounded border-0 shadow overflow-hidden">
                                      <img src={about4} className="img-fluid" alt=""/>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>

              <div className="col-md-6 order-2 order-md-1 mt-4 mt-sm-0 pt-2 pt-sm-0">
                  <div className="section-title">
                      <h4 className="title mb-4">Let's do it together. <br/><span className="text-primary">With our team member</span></h4>
                      <p className="text-muted para-desc">Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                      <ul className="list-inline mb-0">
                          <li className="h6"><i className="mdi mdi-check-circle-outline text-primary h5 mb-0 me-2 align-middle"></i> Can I upgrade later on?</li>
                          <li className="h6"><i className="mdi mdi-check-circle-outline text-primary h5 mb-0 me-2 align-middle"></i> Can I port my data from another provider?</li>
                          <li className="h6"><i className="mdi mdi-check-circle-outline text-primary h5 mb-0 me-2 align-middle"></i> Are my food photos stored forever in the cloud?</li>
                          <li className="h6"><i className="mdi mdi-check-circle-outline text-primary h5 mb-0 me-2 align-middle"></i> Who foots the bill for that?</li>
                      </ul>
                      <div className="mt-4">
                          <Link to="#" className="text-primary">Read More <i className="mdi mdi-chevron-right align-middle"></i></Link>
                      </div>
                  </div>
              </div>
          </div>
      </div>
    </section>

    <section className='position-relative'>
      <BgParallax bg={bg1}/>
      <div className="container">
          <div className="row">
              <div className="col-lg-4 col-md-6">
                  <div className="cta-review bg-dark  shadow rounded p-4">
                      <ClientTwo/>
                  </div>
              </div>
          </div>
      </div>
    </section>

    <section className="section">        
      <div className="container">
          <div className="row mt-5 pt-4">
              <div className="col-12 text-center">
                  <div className="section-title mb-4 pb-2">
                      <h4 className="title mb-4">Our Rates For You</h4>
                      <p className="text-muted para-desc mx-auto mb-0">Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                  </div>
              </div>
          </div>
          <PricingTwo/>
      </div>

      <div className="container mt-100 mt-60">
          <div className="bg-dark bg-cta-dark rounded p-md-5 p-4 p-sm-0 shadow">
              <div className="row align-items-center">
                  <div className="col-sm-7">
                      <div className="text-sm-start">
                          <h4 className="text-white title-dark">Ready to start your project ?</h4>
                          <p className="text-white-50 para-desc para-dark mb-0">Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                      </div>
                  </div>

                  <div className="col-sm-5 mt-4 mt-sm-0">
                      <div className="text-sm-end">
                          <Link to="/contact" className="btn btn-primary"><i className="mdi mdi-phone-outline"></i> Contact Now</Link>
                      </div>
                  </div>
              </div>
          </div>
      </div>
    </section>
    <Footer/>
    </>
  )
}
